import React from "react";

export const FormGroup: React.FC = ({ children }) => {
  return <div className="form-group">{children}</div>;
};
